import { Outlet } from "react-router-dom";
import type { ReactNode } from "react";
import { Sidebar } from "./Sidebar";
import { AccountFrame, ConsoleShell } from "./ConsoleShell";
import { useAuth } from "@/hooks/useAuth";
import { OrganizationRequiredPage } from "@/features/account/OrganizationRequiredPage";
import { InitialKintoneSetupSessionProvider } from "@/features/app-bindings/InitialKintoneSetupSessionContext";
import { PlanStatusBanner } from "@/features/billing/PlanStatusBanner";
import { ConsoleReadStateProvider } from "@/contexts/ConsoleReadState";

export function MainLayout({ requireOrganization = true }: { requireOrganization?: boolean }) {
  const { user } = useAuth();

  if (user?.accountSetupState === "organization_required" || !user?.currentMembership) {
    if (requireOrganization) return <OrganizationRequiredPage />;
    return (
      <AccountFrame>
        <Outlet />
      </AccountFrame>
    );
  }

  return (
    <ConsoleFrame activeCustomerId={user.currentMembership.customerId}>
      <Outlet />
    </ConsoleFrame>
  );
}

export function ConsoleFrame({
  activeCustomerId,
  children,
}: {
  activeCustomerId: string;
  children: ReactNode;
}) {
  return (
    <InitialKintoneSetupSessionProvider
      key={activeCustomerId}
      activeCustomerId={activeCustomerId}
    >
      <ConsoleReadStateProvider>
        <ConsoleShell navigation={<Sidebar />}>
          <PlanStatusBanner className="mx-6 mt-4" />
          {children}
        </ConsoleShell>
      </ConsoleReadStateProvider>
    </InitialKintoneSetupSessionProvider>
  );
}
